














































































































































import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import AdUnit from "@/models/adUnit";
import { AvailabilityNode } from "@/models/availability";
import Campaign, { LineItem } from "@/models/campaign";
import { DefinitionList } from "@/models/definition";
import DefinitionValue from "@/models/definitionValue";
import { LayoutModule } from "@/store/layout";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AvailabilityDetails from "./AvailabilityDetails.vue";

@Component
export default class AvailabilityLayout extends Vue {
  @Prop({ default: "" }) name!: string;
  @Prop() lineItems!: LineItem[];
  @Prop({ default: () => [] }) adUnits!: AdUnit[];
  @Prop({ default: () => [] }) campaigns!: Campaign[];
  @Prop({ default: () => [] }) definitions!: DefinitionList[];
  @Prop({ default: "" }) country!: string;

  @Prop({
    default: () => {
      return {};
    },
  })
  layout!: AvailabilityNode;
  filteredLineItems: LineItem[] = [];
  definition: DefinitionValue = new DefinitionValue();

  get envNameComposed(): string {
    let country_name: DefinitionValue | undefined;

    if (this.country != "") {
      this.definitions.forEach((d) => {
        if (d.value === "country") {
          country_name = d.values.find((v) => v.id === this.country);
        }
      });
    }
    return `${this.name} ${country_name ? " | " + country_name.name : ""}`;
  }

  created(): void {
    this.findDefinitionByName(this.layout.id, "environment");
    this.definition ? this.filterLineItems() : null;
  }

  findDefinitionByName(value: string, type: string): void {
    let definition: DefinitionValue | undefined = new DefinitionValue();
    this.definitions.forEach((d) => {
      if (d.value === type) {
        definition = d.values.find((v) => v.value === value);
      }
    });

    if (!definition) {
      definition = new DefinitionValue({
        name: this.name,
        value: this.name.toLowerCase(),
      });
    }

    this.definition = definition;
  }

  getGroup(type: string): AvailabilityNode {
    const group = this.layout.children?.find(
      (g: AvailabilityNode) => g.name === type
    );

    return group ? group : new AvailabilityNode();
  }

  cleanName(name: string): string | undefined {
    const n = name.split(" ");
    return n.pop();
  }

  _getLineItem(ad_unit_id: string): void {
    const ad_unit = this.adUnits.find((a) => a.id === ad_unit_id);
    let country: DefinitionValue | undefined;

    this.definitions.forEach((d) => {
      const c = d.values.find((v) => {
        return v.id === this.country;
      });

      if (c) {
        country = c;
      }
    });

    const line_item = this.filteredLineItems.find((l) => {
      return (
        l.adUnitId === ad_unit?.id &&
        l.definitionValueIds.includes(country?.id as string)
      );
    });
  }

  getLineItem(
    ad_unit_id: string
  ): { status?: string; name?: string; line_item?: LineItem } {
    let ad_unit = this.adUnits.find((a) => a.id === ad_unit_id);
    let validateCountry =
      this.country !== "" && this.country !== null ? true : false;
    let isAvailable = false;

    let line_items = this.filteredLineItems.filter((l) => {
      if (validateCountry) {
        return (
          l.adUnitId === ad_unit_id &&
          l?.definitionValueIds.includes(this.country)
        );
      } else {
        return l.adUnitId === ad_unit_id;
      }
    });

    let line_item = this.prioritizeActive(line_items);

    let c;
    this.definitions.forEach((d) => {
      const _c = d.values.find((v) => v.id === this.country);
      _c ? (c = _c) : null;
    });

    const campaign = this.campaigns.find((c) => c.id === line_item?.campaignId);

    return {
      status:
        campaign && campaign?.status !== "pending"
          ? campaign.status
          : "available",
      name: campaign ? campaign.name : "",
      line_item: line_item,
    };
  }

  prioritizeActive(line_items: LineItem[]): LineItem {
    let line_item: LineItem | null = new LineItem();
    let active_line_item: LineItem | null = null;
    let reserved_line_item: LineItem | null = null;

    line_items.forEach((l) => {
      const campaign = this.campaigns.find((c) => c.id === l?.campaignId);
      if (campaign?.status === "active") {
        active_line_item = l;
      } else if (campaign?.status === "reserved") {
        reserved_line_item = l;
      } else {
        line_item = l;
      }
    });

    if (active_line_item) {
      line_item = active_line_item;
    } else if (reserved_line_item) {
      line_item = reserved_line_item;
    }

    return line_item;
  }

  containDefinition(l: LineItem, value: string): boolean {
    let match = false;
    let BreakException = {};

    try {
      this.definitions.forEach((e) => {
        if (e.value === value) {
          match = l.definitionValueIds.includes(e.id ? e.id : "")
            ? true
            : false;

          if (match) throw BreakException;
        }
      });
    } catch (e) {
      console.log(e);

      if (e !== BreakException) throw e;
    }

    return match;
  }

  getColorStatus(status: string): string | undefined {
    const color = CAMPAIGN_STATUS_LIST.find((e) => e.key === status);
    return color ? color.class : "grey";
  }

  showDetails(adUnit: AvailabilityNode): void {
    const props = {
      adUnitId: adUnit.id,
      lineItems: this.filteredLineItems,
      campaigns: this.campaigns,
      definitions: this.definitions,
      environment: this.definition,
      country: this.country != "" ? this.country : null,
    };

    LayoutModule.setRightDrawerComponent(AvailabilityDetails);
    LayoutModule.setRightDrawerComponentProps(props);
    LayoutModule.showRightDrawer();
  }

  filterLineItems(): void {
    let l: LineItem[] = this.lineItems.filter((v) =>
      v.definitionValueIds.includes(
        this.definition.id ? this.definition.id : ""
      )
    );

    if (l.length === 0) {
      const ad_units: AdUnit[] = this.getAdUnitsByNameMatch();

      l = this.lineItems.filter((v) => {
        const ad_unit = ad_units.find((a) => a.id === v.adUnitId);
        return ad_unit ? true : false;
      });
    }

    this.filteredLineItems = l;
  }

  getAdUnitsByNameMatch(): AdUnit[] {
    return this.adUnits.filter((a) => {
      return a.name.toLowerCase().includes(this.definition.value);
    });
  }
}
